import { XCircleIcon } from '@heroicons/react/24/outline'
import React from 'react'
import pdfImg from '../../assets/pdf-img.png'
import photoImg from '../../assets/photo-img.png'
import './index.scss'
import { AttachmentEntity } from '../../customEntites/Attachment.entity'
import LoadingOverlay from '../LoadingOverlay'
import { useTranslation } from 'react-i18next'

const ImagePreview = ({
  attachments,
  uploader,
  download,
  remove,
  setAttachments
}: {
  attachments: AttachmentEntity[],
  uploader?: any,
  download?: boolean | undefined,
  remove?: boolean | undefined,
  setAttachments?: any
}) => {
  const { t } = useTranslation()
  const downloadFile = (file: File) => {
    const url = window.URL.createObjectURL(file)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display: none;')
    a.href = url
    a.download = file?.name
    a.click()
    window.URL.revokeObjectURL(url)
  }
  const onRemoveAttachment = (index: number) => {
    const newAttachments = [...attachments]
    newAttachments.splice(index, 1)
    setAttachments(newAttachments)
  }
  return (
    <div className='uploaded-images-holder' role='list'>
      {attachments.map((file: AttachmentEntity, index: number) => {
        const actualFile: any = file?.file || file
        const isDownload = download && !file?.customProperties?.uploading
        const isPDF = actualFile.type === 'application/pdf'
        const isUploading = file?.customProperties?.uploading
        const imageSrc = isPDF
          ? pdfImg
          : isUploading
            ? photoImg
            : URL.createObjectURL(actualFile)

        return (
          <div
            key={index}
            className={`uploaded-image-holder ${isDownload ? 'download' : ''}`}
            role='listitem'
          >
            {isUploading && (
              <LoadingOverlay uploading={true} position='absolute' />
            )}
            {remove && (
              <button
                type='button'
                onClick={() => onRemoveAttachment(index)}
                className='delete-attachment-button'
                aria-label={`${t('BUTTON.DELETE')} ${actualFile.name}`}
              >
                <XCircleIcon
                  aria-hidden='true'
                  title='Delete Attachment'
                />
              </button>
            )}

            {isDownload ? (
              <button
                type='button'
                className='image-download-button'
                onClick={() => downloadFile(actualFile)}
                aria-label={`${t('BUTTON.DOWNLOAD')} ${actualFile.name}`}
              >
                <img
                  src={imageSrc}
                  alt=""
                  aria-hidden="true"
                />
              </button>
            ) : (
              <img
                src={imageSrc}
                alt=""
                aria-hidden="true"
              />
            )}
          </div>
        )
      })}

      {uploader && (
        <div role="listitem">
          {uploader}
        </div>
      )}
    </div>
  )
}

export default ImagePreview
